import {makeAutoObservable} from "mobx"
import {RealDevice} from "dto/realdevice/devices"
import {AdminStore} from "store/admin/admin.store"
import {Category} from "dto/category/category"

export class RealDeviceStore {
    adminStore: AdminStore
    page: number = 0
    size: number = 10
    showRegisterDeviceWindow: boolean = false
    keyword?: string = ""
    selectedDevice?: RealDevice

    selectedCategory: Category | undefined = undefined

    constructor(adminStore: AdminStore) {
        this.adminStore = adminStore
        makeAutoObservable(this)
    }

    setShowRegisterDeviceWindow = (show: boolean) => {
        this.showRegisterDeviceWindow = show
    }

    setPage = (page: number) => {
        this.page = page
    }

    setKeyword = (keyword: string) => {
        this.keyword = keyword
    }

    selectDevice = (device?: RealDevice) => {
        if (device) {
            this.selectedDevice = {...device}
        } else {
            this.selectedDevice = undefined
        }
    }

    selectCategory = (category: Category | undefined) => {
        this.selectedCategory = category
    }
}


